// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.board-radius[data-v-438bd9ae] {\r\n  border-radius: 4px;\n}\n.dot[data-v-438bd9ae] {\r\n  background-color: #ff7058;\r\n  -webkit-box-shadow: 0px 3px 6px #00000029;\r\n          box-shadow: 0px 3px 6px #00000029;\r\n  margin: 2px;\r\n  width: 45px;\r\n  height: 43px;\r\n  border-radius: 50%;\r\n  border-style: solid;\r\n  border-width: 3px;\r\n  border-color: #fff;\r\n  display: inline-block;\n}\r\n\r\n/* .orange-icon-badge-align {\r\n  vertical-align: top;\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
